import script from "./UnderView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderView.vue?vue&type=script&setup=true&lang=js"

import "./UnderView.vue?vue&type=style&index=0&id=5a374310&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Y\\Desktop\\guo-wei\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a374310"]])

export default __exports__